module.exports = __webpack_public_path__ + "f95b49365626ef196fd22fe7f179f8e1.MP3";